import { CssBaseline } from '@mui/material'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { createContext, useContext, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toggleThemeMode } from '../state/theme'
import { createAppTheme } from './createTheme'
import { darkPalette, lightPalette } from './palettes'

const ThemeContext = createContext({
  mode: 'light',
  toggleTheme: () => {},
  setMode: () => {},
  palette: lightPalette
})

export const useThemeMode = () => {
  const context = useContext(ThemeContext)
  return context
}

export const ThemeProvider = ({ children }) => {
  const dispatch = useDispatch()
  const mode = useSelector((state) => state?.theme?.mode || 'light')

  const palette = mode === 'light' ? lightPalette : darkPalette
  const theme = useMemo(() => createAppTheme(palette), [palette])

  const value = useMemo(() => ({
    mode,
    toggleTheme: () => dispatch(toggleThemeMode()),
    palette
  }), [mode, palette, dispatch])

  return (
    <ThemeContext.Provider value={value}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  )
}
